import * as React from "react"
import * as _ from "lodash"
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import IStaticDataValue from "../../../../../common/models/IStaticDataValue";
import {ITypeFormQuestionnaire} from "../../../models/ITypeFormQuestionnaire";
import ToggleButtonList from "../../ToggleButtonList";
import IDietRecall from "../../../models/IDietRecall";
import IDietRecallMealItem from "../../../models/IDietRecallMealItem";
import {MEAL_DAYS} from "../../itemEditor/DietRecallItemEditor";
import IDishCatalogueResponse from "../../../models/maverick/IDishCatalogueResponse";
import HorizontalTagsListView from "../../HorizontalTagsListView";
import TypeAhead, { TypeAheadElement } from "../../TypeAhead";

/**
 * Created by aditya on 16/04/18.
 */


export interface PatientDietRecallEditorProps {
    patientId?: number,
    staticFoodTypes: IStaticDataValue[],
    staticCuisines: IStaticDataValue[],
    updatedDietInfo: {item: IDietRecall},
    updateDietInfo: (updatedDietInfo: {item: IDietRecall}) => void,
    fetchStaticSymptomData: (input: string) => Promise<any>;
    fetchDishByDishName: (input: string) => Promise<IDishCatalogueResponse[]>;
    questionnaire?: ITypeFormQuestionnaire[];
    questionIdList?: string[];
}

export interface PatientDietRecallEditorState {
    formattedMeals: IDietRecallMealItem[][];
    foodDislikesv1: string;
    fruitsv1: string;
    vegetablesv1: string;
    beveragesv1: string;
    meatsv1: string;
    breadsv1: string;
    lentilsv1: string;
}

class PatientDietRecallEditor extends React.Component<PatientDietRecallEditorProps, PatientDietRecallEditorState> {

    constructor(props: PatientDietRecallEditorProps) {
        super(props);
        let meals = this.getFormattedMealsStateFromProps(props);
        this.state = {
            formattedMeals: meals,
            foodDislikesv1: "",
            fruitsv1: "",
            vegetablesv1: "",
            beveragesv1: "",
            meatsv1: "",
            breadsv1: "",
            lentilsv1: ""
        }
    }

    updateStateToValue = (stateKey: string, value: any, callback: any) => {
        switch (stateKey) {
            case "fruitsv1":
                this.setState({fruitsv1 : value}, callback);
                break;
            case "vegetablesv1":
                this.setState({vegetablesv1 : value}, callback);
                break;
            case "beveragesv1":
                this.setState({beveragesv1 : value}, callback);
                break;
            case "meatsv1":
                this.setState({meatsv1 : value}, callback);
                break;
            case "breadsv1":
                this.setState({breadsv1 : value}, callback);
                break;
            case "lentilsv1":
                this.setState({lentilsv1 : value}, callback);
                break;
            case "foodDislikesv1":
                this.setState({foodDislikesv1 : value}, callback);
                break;
        }
    }
    getFormattedMealsStateFromProps = (props: PatientDietRecallEditorProps) => {
        let mealItems: IDietRecallMealItem[][] = [];
        let meals = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.meals) ?
            this.props.updatedDietInfo.item.meals : [];
        let allSlots = meals.map(item => item.mealType);
        let uniqueSlots = _.uniq(allSlots);
        _.map(uniqueSlots, (slot) => {
            let slotMeals = meals.filter(item => item.mealType === slot);
            mealItems.push(slotMeals);
        })
        return mealItems;
    }

    getMealItemProps = () => {
        let mealItems: {item: IDietRecallMealItem[]}[] = [];
        let meals = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.meals) ?
            this.props.updatedDietInfo.item.meals : [];
        let allSlots = meals.map(item => item.mealType);
        let uniqueSlots = _.uniq(allSlots);
        _.map(uniqueSlots, (slot) => {
            let slotMeals = meals.filter(item => item.mealType === slot);
            mealItems.push({item: slotMeals});
        })
        return mealItems;
    }

    getMealSaveObject = () => {
        let meals: IDietRecallMealItem[] = [];
        _.map(this.state.formattedMeals, (meal) => {
            meals = meals.concat(meal);
        })
        return meals;
    }

    onMealRemove = (index: number) => {
        let dietInfo = this.props.updatedDietInfo.item;
        let currUpdatedMeals = Object.assign([], this.state.formattedMeals);
        currUpdatedMeals.splice(index, 1);
        this.setState({
            formattedMeals: currUpdatedMeals
        }, () => {
            dietInfo.meals = this.getMealSaveObject();
            this.props.updateDietInfo({item: dietInfo});
        })
    }

    onMealChange = (updatedMealInfo: {item: IDietRecallMealItem[]}, index: number) => {
        let dietInfo = this.props.updatedDietInfo.item;
        let currUpdatedMeals = Object.assign([], this.state.formattedMeals);
        currUpdatedMeals[index] = updatedMealInfo.item;
        this.setState({
            formattedMeals: currUpdatedMeals
        }, () => {
            dietInfo.meals = this.getMealSaveObject();
            this.props.updateDietInfo({item: dietInfo});
        })
    }

    onPreferredFoodOptionsChange = (items: string[]) => {
        let dietInfo = { ...this.props.updatedDietInfo.item };
        let preferredFoodTypes = !_.isEmpty(dietInfo.preferredFoodTypesv1) ? dietInfo.preferredFoodTypesv1 : { value: null as any, comment: null as any };
        let convertedItems = items.map(item => this.props.staticFoodTypes.find(foodType => foodType.internalValue === item));
        preferredFoodTypes.value = convertedItems;
        dietInfo.preferredFoodTypesv1 = preferredFoodTypes;
        this.props.updateDietInfo({ item: dietInfo });
    }

    onPreferredCuisinesChange = (items: string[]) => {
        let dietInfo = { ...this.props.updatedDietInfo.item };
        let preferredCuisines = !_.isEmpty(dietInfo.preferredCuisinesv1) ? dietInfo.preferredCuisinesv1 : { value: null, comment: null };
        let convertedItems = items.map(item => this.props.staticCuisines.find(cuisine => cuisine.internalValue === item));
        preferredCuisines.value = convertedItems;
        dietInfo.preferredCuisinesv1 = preferredCuisines;
        this.props.updateDietInfo({ item: dietInfo });
    }

    handleTypeAheadChange = (input: string, stateKey: string) => {
        this.updateStateToValue(stateKey, input, null);
        return this.props.fetchDishByDishName(input).then((dishes: IDishCatalogueResponse[]) => {
            let dishTypeAhead: TypeAheadElement[] = [];
            if (input !== "") {
                let defaultTypeAheadElement = { value: "", label: input, isDefault: true };
                dishTypeAhead.push(defaultTypeAheadElement);
            }
            _.map(dishes, (dish: IDishCatalogueResponse) => {
                let typeAheadElement: TypeAheadElement = {
                    value: dish.esId,
                    label: dish.name
                }
                dishTypeAhead.push(typeAheadElement);
            })
            return Promise.resolve({options: dishTypeAhead, completed: true});
        }).catch((error: any) => {
            throw error;
        });
    }

    onListItemRemove = (index: number, dientInfoItemsKey: string) => {
        let dietInfo: any = { ...this.props.updatedDietInfo.item };
        let updatedList = dietInfo[dientInfoItemsKey];
        updatedList.splice(index, 1);
        dietInfo[dientInfoItemsKey] = updatedList;
        this.props.updateDietInfo({ item: dietInfo });
    }

    handleListItemTypeAheadSelect = (elem: TypeAheadElement, key: string) => {
        let dietInfo: any = { ...this.props.updatedDietInfo.item };
        let updatedList = !_.isEmpty(dietInfo[key]) ? dietInfo[key] : [];
        updatedList = [...updatedList, { internalValue: elem.label, displayValue: elem.label, comment: "" }];
        dietInfo[key] = updatedList;

        this.updateStateToValue(key, "", () => {
            this.props.updateDietInfo({ item: dietInfo })
        });
    }

    onFoodDislikesRemove = (index: number) => {
        let dietInfo = { ...this.props.updatedDietInfo.item };
        let updatedFoodDislikes = dietInfo.foodDislikesv1;
        updatedFoodDislikes.splice(index, 1);
        dietInfo.foodDislikesv1 = updatedFoodDislikes;
        this.props.updateDietInfo({ item: dietInfo });
    }

    handleFoodDislikeTypeAheadSelect = (elem: TypeAheadElement) => {
        let dietInfo = { ...this.props.updatedDietInfo.item };
        let updatedFoodDislikes = !_.isEmpty(dietInfo.foodDislikesv1) ? dietInfo.foodDislikesv1 : [];
        updatedFoodDislikes = [...updatedFoodDislikes, { internalValue: elem.label, displayValue: elem.label, comment: "" }];
        dietInfo.foodDislikesv1 = updatedFoodDislikes;
        this.setState({
            foodDislikesv1: ""
        }, () => {
            this.props.updateDietInfo({ item: dietInfo });
        })
    }

    createDefaultFormattedMealItem = (): {item: IDietRecallMealItem[]} => {
        let dietRecallMealItems = [];
        let item = ModelFactory.createNewDietRecallMealItem();
        item.day = MEAL_DAYS.WEEKDAY;
        dietRecallMealItems.push(item);
        item = ModelFactory.createNewDietRecallMealItem();
        item.day = MEAL_DAYS.WEEKEND;
        dietRecallMealItems.push(item);
        return {item: dietRecallMealItems};
    }

    render() {
        let selectedFoodTypes: any[] = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.preferredFoodTypesv1) && this.props.updatedDietInfo.item.preferredFoodTypesv1.value ?
            this.props.updatedDietInfo.item.preferredFoodTypesv1.value.map(item => !_.isNull(item.internalValue) ? item.internalValue : item.displayValue ) : [];
        let selectedCuisines: any[] = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.preferredCuisinesv1) && this.props.updatedDietInfo.item.preferredCuisinesv1.value ?
            this.props.updatedDietInfo.item.preferredCuisinesv1.value.map(item => !_.isNull(item.internalValue) ? item.internalValue : item.displayValue ) : [];

        const preferredFruitsTagsList = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.fruitsv1) ? this.props.updatedDietInfo.item.fruitsv1.map(item => item.displayValue) : [];
        const preferredVegetablesTagsList = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.vegetablesv1) ? this.props.updatedDietInfo.item.vegetablesv1.map(item => item.displayValue) : [];
        const preferredBeveragesTagsList = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.beveragesv1) ? this.props.updatedDietInfo.item.beveragesv1.map(item => item.displayValue) : [];
        const preferredMeatsTagsList = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.meatsv1) ? this.props.updatedDietInfo.item.meatsv1.map(item => item.displayValue) : [];
        const preferredBreadsTagsList = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.breadsv1) ? this.props.updatedDietInfo.item.breadsv1.map(item => item.displayValue) : [];
        const preferredLentilsTagsList = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.lentilsv1) ? this.props.updatedDietInfo.item.lentilsv1.map(item => item.displayValue) : [];
        const foodDislikesTagsList = !_.isEmpty(this.props.updatedDietInfo.item) && !_.isEmpty(this.props.updatedDietInfo.item.foodDislikesv1) ? this.props.updatedDietInfo.item.foodDislikesv1.map(item => item.displayValue) : [];
        return (
            <div className="patient-diet-recall-editor">
                <div className={"preferred-food-types-container"}>
                    <div className={"label"}>Preferred Food types</div>
                    <div className={"buttons-container"}>
                        <ToggleButtonList listItems={this.props.staticFoodTypes} selectedItems={selectedFoodTypes} onSelectionChange={this.onPreferredFoodOptionsChange}/>
                    </div>
                </div>
                <div className={"preferred-cuisines-container"}>
                    <div className={"label"}>Preferred Cuisines</div>
                    <div className={"buttons-container"}>
                        <ToggleButtonList listItems={this.props.staticCuisines} selectedItems={selectedCuisines} onSelectionChange={this.onPreferredCuisinesChange}/>
                    </div>
                </div>
                <div className={"food-dislikes-wrapper-container"}>
                    <div className={"label"}>Fruits</div>
                    <div className="food-dislikes-container">
                        <HorizontalTagsListView tagsStringArray={preferredFruitsTagsList} onTagRemove={e => this.onListItemRemove(e, "fruitsv1")} />
                        <TypeAhead widgetName={"PatientDietRecall"} name={"preferred-fruits"} value={this.state.fruitsv1} placeholder={"Start typing fruit name"} onTypeAheadChange={e => this.handleTypeAheadChange(e, "fruitsv1")} onTypeAheadSelect={e => this.handleListItemTypeAheadSelect(e, "fruitsv1")}/>
                    </div>
                </div>
                <div className={"food-dislikes-wrapper-container"}>
                    <div className={"label"}>Vegetables</div>
                    <div className="food-dislikes-container">
                        <HorizontalTagsListView tagsStringArray={preferredVegetablesTagsList} onTagRemove={e => this.onListItemRemove(e, "vegetablesv1")} />
                        <TypeAhead widgetName={"PatientDietRecall"} name={"preferred-fruits"} value={this.state.vegetablesv1} placeholder={"Start typing vegetable name"} onTypeAheadChange={e => this.handleTypeAheadChange(e, "vegetablesv1")} onTypeAheadSelect={e => this.handleListItemTypeAheadSelect(e, "vegetablesv1")}/>
                    </div>
                </div>
                <div className={"food-dislikes-wrapper-container"}>
                    <div className={"label"}>Beverages</div>
                    <div className="food-dislikes-container">
                        <HorizontalTagsListView tagsStringArray={preferredBeveragesTagsList} onTagRemove={e => this.onListItemRemove(e, "beveragesv1")} />
                        <TypeAhead widgetName={"PatientDietRecall"} name={"preferred-fruits"} value={this.state.beveragesv1} placeholder={"Start typing beverage name"} onTypeAheadChange={e => this.handleTypeAheadChange(e, "beveragesv1")} onTypeAheadSelect={e => this.handleListItemTypeAheadSelect(e, "beveragesv1")}/>
                    </div>
                </div>
                <div className={"food-dislikes-wrapper-container"}>
                    <div className={"label"}>Meat</div>
                    <div className="food-dislikes-container">
                        <HorizontalTagsListView tagsStringArray={preferredMeatsTagsList} onTagRemove={e => this.onListItemRemove(e, "meatsv1")} />
                        <TypeAhead widgetName={"PatientDietRecall"} name={"preferred-fruits"} value={this.state.meatsv1} placeholder={"Start typing meat name"} onTypeAheadChange={e => this.handleTypeAheadChange(e, "meatsv1")} onTypeAheadSelect={e => this.handleListItemTypeAheadSelect(e, "meatsv1")}/>
                    </div>
                </div>
                <div className={"food-dislikes-wrapper-container"}>
                    <div className={"label"}>Bread</div>
                    <div className="food-dislikes-container">
                        <HorizontalTagsListView tagsStringArray={preferredBreadsTagsList} onTagRemove={e => this.onListItemRemove(e, "breadsv1")} />
                        <TypeAhead widgetName={"PatientDietRecall"} name={"preferred-fruits"} value={this.state.breadsv1} placeholder={"Start typing bread name"} onTypeAheadChange={e => this.handleTypeAheadChange(e, "breadsv1")} onTypeAheadSelect={e => this.handleListItemTypeAheadSelect(e, "breadsv1")}/>
                    </div>
                </div>
                <div className={"food-dislikes-wrapper-container"}>
                    <div className={"label"}>Lentils</div>
                    <div className="food-dislikes-container">
                        <HorizontalTagsListView tagsStringArray={preferredLentilsTagsList} onTagRemove={e => this.onListItemRemove(e, "lentilsv1")} />
                        <TypeAhead widgetName={"PatientDietRecall"} name={"preferred-fruits"} value={this.state.lentilsv1} placeholder={"Start typing lentil name"} onTypeAheadChange={e => this.handleTypeAheadChange(e, "lentilsv1")} onTypeAheadSelect={e => this.handleListItemTypeAheadSelect(e, "lentilsv1")}/>
                    </div>
                </div>
                <div className={"food-dislikes-wrapper-container"}>
                    <div className={"label"}>Dislikes in food</div>
                    <div className="food-dislikes-container">
                        <HorizontalTagsListView tagsStringArray={foodDislikesTagsList} onTagRemove={this.onFoodDislikesRemove} />
                        <TypeAhead widgetName={"PatientDietRecall"} name={"food-dislikes"} value={this.state.foodDislikesv1} placeholder={"Start typing dish name"} onTypeAheadChange={e => this.handleTypeAheadChange(e, "foodDislikesv1")} onTypeAheadSelect={e => this.handleListItemTypeAheadSelect(e, "foodDislikesv1")}/>
                    </div>
                </div>
                <div className={"meal-builder-container"}>
                    <TemplatedList templateName={"dietRecall"} commonProps={{fetchDishByDishName: this.props.fetchDishByDishName}}
                                   defaultItem={this.createDefaultFormattedMealItem()}
                                   listItems={this.getMealItemProps()}
                                   onItemRemove={this.onMealRemove}
                                   onItemChange={this.onMealChange}
                                   allSelectedMealSlots={
                                       this.props.updatedDietInfo.item && this.props.updatedDietInfo.item.meals
                                        ? this.props.updatedDietInfo.item.meals.filter((meal,index) => index % 2 === 0)
                                        : []
                                    }/>
                </div>
            </div>
        );
    }
}

export default PatientDietRecallEditor